import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './styles/immobilien.css';
import './styles/kontakte.css';
import './styles/portal.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// #602: Nach einem Update fehlen alte Programmteile – statt weißer Seite einmal frisch laden
// (Schutz gegen Endlosschleife: höchstens einmal je Minute).
window.addEventListener('vite:preloadError', (e) => {
  try {
    const zuletzt = Number(sessionStorage.getItem('immo-neu-geladen') || 0);
    if (Date.now() - zuletzt < 60_000) return;
    sessionStorage.setItem('immo-neu-geladen', String(Date.now()));
  } catch { /* ohne Speicher trotzdem neu laden */ }
  e.preventDefault();
  window.location.reload();
});

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

/**
 * PWA Service Worker Registration
 * Vereinfacht für maximale Kompatibilität mit Sandboxes und Produktiv-Domains.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isDev = (import.meta as any).env?.DEV === true;

    // Im Dev-Modus: bestehende SWs deregistrieren und Caches leeren — sonst hängt man am alten Bundle.
    if (isDev || isLocalhost) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => reg.unregister());
      });
      if ('caches' in window) {
        caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
      }
      console.info('PWA: ServiceWorker im Dev-Modus deaktiviert.');
      return;
    }

    const isSecureContext = window.isSecureContext || window.location.protocol === 'https:';
    if (isSecureContext) {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('PWA: ServiceWorker registriert (Scope: ' + registration.scope + ')');
        })
        .catch((error) => {
          if (window.location.hostname.includes('usercontent.goog')) {
            console.info('PWA: ServiceWorker in Sandbox blockiert. Funktioniert später auf immoschwede.de einwandfrei.');
          } else {
            console.warn('PWA: Registrierung fehlgeschlagen:', error);
          }
        });
    }
  });
}